module.exports = __webpack_public_path__ + "img/box-after.57d87268.svg";